export const navigation = [
    { to: "/work", text: "Work" },
    { to: "/clients", text: "Clients" },
    { to: "/people", text: "People" },
    { to: "/careers", text: "Careers" },
    { to: "/news", text: "News" },
    { to: "/contact", text: "Contact" }
];



// WEBPACK FOOTER //
// ./src/utils/config.js